(function () {
  /**
   * Custom logic for Silver Stories page (Both Mobile and Desktop)
   * - Ensures 'Shop the Look' aside remains open/restored correctly.
   * - Blocks the cart drawer from automatically popping up during the flow.
   * - AGGRESSIVELY handles the cart icon click to prevent "double-click" or "open-and-close" bugs.
   */
  function setupSilverStoriesCustom() {
    var templateName = window.templateSuffix || "";
    var isSilverStories =
      window.location.href.includes("/pages/silver-stories") ||
      templateName === "rings-stack-2" ||
      document.body.classList.contains("template-page--rings-stack-2") ||
      document.body.classList.contains("rings-stack-2") ||
      window.location.href.includes("rings-stack-2");
    if (!isSilverStories) return;

    // 1. CSS to hide the drawer when explicitly blocked
    var styleId = "silver-stories-custom-styles";
    if (!document.getElementById(styleId)) {
      var style = document.createElement("style");
      style.id = styleId;
      style.innerHTML =
        ".drawer--cart.force-hide { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }";
      document.head.appendChild(style);
    }

    var lastOpenAside = null;

    function blockDrawer() {
      var drawer = document.querySelector(".drawer--cart");
      if (drawer) drawer.classList.add("force-hide");
    }

    function unblockDrawer() {
      var drawer = document.querySelector(".drawer--cart");
      if (drawer) drawer.classList.remove("force-hide");

      // Remove all possible blocker styles
      var otherBlockers = [
        "silver-stories-drawer-block",
        "silver-stories-look-drawer-block",
        "block-cart-drawer-silver-stories",
      ];
      otherBlockers.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.remove();
      });
    }

    // 2. EXTREMELY AGGRESSIVE CLICK HANDLER FOR CART ICON
    // We listen to multiple events and use capture phase to prevent ANY theme interference
    ["click", "mousedown", "touchstart"].forEach(function (eventName) {
      document.addEventListener(
        eventName,
        function (e) {
          var cartIcon = e.target.closest(".navlink--cart, [data-cart-toggle]");
          if (!cartIcon) return;

          // Stop the theme's logic from ever seeing this event
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Only perform the "open" action once (on click)
          if (eventName === "click") {
            unblockDrawer();
            var drawer = document.querySelector(".drawer--cart");
            if (drawer) {
              // Force the drawer into the OPEN state (not a toggle)
              drawer.classList.add("is-open");
              document.body.classList.add("has-drawer-open");
              document.documentElement.classList.add("is-locked");
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", { bubbles: true }),
              );

              // Force cart content update
              if (window.cart && typeof window.cart.getCart === "function") {
                window.cart.getCart();
              }
            }
            lastOpenAside = null;
          }
        },
        true,
      );
    });

    // 3. Aside/Look logic tracking
    document.addEventListener(
      "click",
      function (e) {
        // Shop the Look bag icon / thumb clicked
        var trigger = e.target.closest("[data-slider-thumb]");
        if (trigger) {
          var section = trigger.closest(".shopify-section");
          if (section) {
            lastOpenAside = section.querySelector(".look__aside");
            blockDrawer();
          }
        }

        // Manual close clicked
        if (
          e.target.closest(
            "[data-popup-close], [data-cart-drawer-close], .drawer__close, [data-drawer-underlay]",
          )
        ) {
          lastOpenAside = null;
          setTimeout(unblockDrawer, 50);
        }
      },
      true,
    );

    // 4. Restore Aside Logic
    var restoreAsideWhenClosed = function () {
      if (!lastOpenAside) return;

      blockDrawer();

      var aside = lastOpenAside;
      setTimeout(function () {
        // Clear theme's internal drawer state
        var drawer = document.querySelector(".drawer--cart");
        if (drawer && drawer.classList.contains("is-open")) {
          drawer.classList.remove("is-open");
          document.body.classList.remove("has-drawer-open");
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: true }),
          );
        }

        if (aside && !aside.classList.contains("is-open")) {
          aside.classList.add("is-open");
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: true }),
          );
        }
        aside.classList.remove("is-animating");

        setTimeout(unblockDrawer, 300);
      }, 250);
    };

    // Listen for theme events
    document.addEventListener("theme:quick-add:open", restoreAsideWhenClosed);
    document.addEventListener("theme:product:added", restoreAsideWhenClosed);
    document.addEventListener("theme:cart:change", restoreAsideWhenClosed);
  }

  // Init
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupSilverStoriesCustom);
  } else {
    setupSilverStoriesCustom();
  }
})();
